export function getPostCssOptions(options) {
  return {
    plugins: () => {
      if (options && Array.isArray(options.postCss)) {
        return options.postCss;
      }
      return [
        require('postcss-nested')(),
        require('pixrem')(),
        require('autoprefixer')(
          options && options.autoprefixer
            ? options.autoprefixer
            : {
                browsers: ['last 2 versions', 'Firefox ESR', '> 1%', 'ie >= 8'],
              },
        ),
        require('postcss-flexibility')(),
        require('postcss-discard-duplicates')(),
      ];
    },
    config: {
      path: options.postcssPath || __dirname,
    },
  };
}
